import {Component} from "react";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import React from "react";
import PracownicyTable from "./components/PracownicyTable";
import PracownicyService from "./PracownicyService";
import PracownicyForm from "./components/PracownicyForm";
import TopIf from "../../../componentsTopsa/if/TopIf";
import {TopButtonAdd} from "../../../componentsTopsa/buttons/TopButtons";
import ReactNotify from "react-notify";
import ScrollUtilities from "../../../utilities/ScrollUtilities";

export default class PracownicyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pracownicy: [],
            pokazFormularz: false,
            edytowany: null
        };
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.zamknijForm = this.zamknijForm.bind(this)
    }

    componentDidMount() {
        this.pobierzPracownikow()
    }

    pobierzPracownikow() {
        PracownicyService.getPracownicy().then(function (response) {
            this.setState({pracownicy: response.data.content})
        }.bind(this))
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({pokazFormularz: true, edytowany: obj})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc pracownika: ' + obj.imie + ' ' + obj.nazwisko)) {
            PracownicyService.deletePracownik(obj.idPr).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto pracownika', "", 3000)
                    this.pobierzPracownikow()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas uwuwania pracownika', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            PracownicyService.editPracownik(this.state.edytowany.idPr, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano pracownika', "", 3000)
                    this.pobierzPracownikow()
                    this.zamknijForm()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji pracownika', "", 3000)
                }
            }.bind(this))
        }
        else {
            PracownicyService.addPracownik(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano pracownika', "", 3000)
                    this.pobierzPracownikow()
                    this.zamknijForm()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania pracownika', "", 3000)
                }
            }.bind(this))
        }
    }

    zamknijForm() {
        this.setState({edytowany: null, pokazFormularz: false})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'KonfiguracjaContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/pracownicy',
                                    text: 'Pracownicy'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <PracownicyForm handleClickAnuluj={this.zamknijForm} handleClickZapisz={this.onClickZapisz}
                                                edytowany={this.state.edytowany}/>
                            </TopIf>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <div className={'pull-right'}>
                                    <TopButtonAdd onClick={() => {
                                        this.setState({pokazFormularz: true});
                                        ScrollUtilities.scrollToTop()
                                    }} text={'Dodaj pracownika'}/>
                                </div>
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <PracownicyTable data={this.state.pracownicy} handleEdytuj={this.onClickEdytuj} handleUsun={this.onClickUsun}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/administracja/pracownicy/PracownicyContainer.js